module.exports = new __parcel__URL__("insights.tpl.c29b665e.svg").toString();